import { Row } from '@/components/grid/grid-component';
import {
  MdOutlineEdit,
  MdArrowDropDown,
  MdOutlineFileUpload,
  MdOutlineQueryStats,
  MdMultipleStop,
  MdPlaylistAdd,
} from 'react-icons/md';
import styled from 'styled-components';

const StyledMainRow = styled(Row)`
  display: flex;
  justify-content: space-between !important;
  margin-bottom: 20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 32px !important;
  border-radius: 6px;
  width: 100%;
  background-color: ${({ theme }) => theme.COLOR_BLACK} !important;
`;

const MainContainer = styled(Row)`
  margin-bottom: 20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 32px !important;
`;

const StepDivider = styled.div`
  border-left: 2px solid #ffffff;
  width: 1px;
  height: 44px;
  transform: rotate(0deg);
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
`;

const EditIcon = styled(MdOutlineEdit)`
  margin-right: 10px;
  cursor: pointer;
  height: 24px;
  width: 24px;
`;

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SupplierSelectDiv = styled.div`
  margin-top: 15px;
  width: 25%;
`;

const OptionNavlink = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 40px;

  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.COLOR_GREY5};
      color: #000;
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0.2px;
      text-align: left;
    }
  }
`;

const DropDown = styled.div`
  position: fixed;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 10;
  border-width: 0px 0px 0px 0px;
  border-style: solid;
  border-color: #eaedf3;
  border-radius: 4px;
  left: ${({ $position }) => $position.x}px;
  top: ${({ $position }) => $position.y}px;
`;

const DropDownIcon = styled(MdArrowDropDown)`
  margin: 0 0 0 0;
  top: 10px;
  font-size: 25px;

  svg.dropdown-icon {
    margin: 0 0 0 0;
    top: 10px;
  }
`;

const AddPriceListIcon = styled(MdOutlineFileUpload)`
  margin-right: 10px;
`;

const AddPriceRowIcon = styled(MdPlaylistAdd)`
  margin-right: 10px;
`;

const MigratePriceListIcon = styled(MdMultipleStop)`
  margin-right: 10px;
`;

const EditGlobalMarkupIcon = styled(MdOutlineQueryStats)`
  margin-right: 10px;
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: #eaedf3 !important;
  margin-bottom: 0px !important;
  padding: 24px !important;
  justify-content: space-between !important;
  margin-right: auto !important;
  margin-left: auto !important;
`;

const OutsideClickHandler = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
`;

const styledPricingAll = {
  StyledMainRow,
  StyledDiv,
  Heading,
  RowStyle,
  EditIcon,
  StepDivider,
  SupplierSelectDiv,
  MainContainer,
  OptionNavlink,
  DropDown,
  DropDownIcon,
  AddPriceListIcon,
  AddPriceRowIcon,
  EditGlobalMarkupIcon,
  MigratePriceListIcon,
  OutsideClickHandler,
};

export default styledPricingAll;
